/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react';
import { Link } from "react-router-dom";
import { AuthContext } from '../../context/auth-context';
import { CoreContext } from '../../context/core-context';
import headerImage from '../../assets/images/navodaya_banner.jpg';
import { Badge } from 'react-bootstrap';

const Menu = (props) => {
    const authContext = useContext(AuthContext);
    const coreContext = useContext(CoreContext);

    const isAdmin = authContext.item.smst_designation === 'Admin' || authContext.item.smst_designation === 'Moderator';
    const isAuth = authContext.isAuth && authContext.itemId;

    return (
        <header className="mb-3">
            {/* Top Navigation Bar */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-dark py-2 px-3 shadow-sm rounded mb-3" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)' }}>
                <div className="container-fluid px-0 d-flex justify-content-between align-items-center flex-wrap gap-2">
                    {/* Left Actions */}
                    <div className="d-flex align-items-center gap-2">
                        <Link className="btn btn-outline-light btn-sm" to='/'>
                            <span className="me-1">🏠</span> Home
                        </Link>
                        {isAdmin && (
                            <Link className="btn btn-warning btn-sm font-weight-bold" to='/applicants'>
                                ⚙️ Admin Panel
                            </Link>
                        )}
                    </div>

                    {/* Middle Branding (Optional Title for small screens) */}
                    <div className="text-center d-none d-md-block">
                        <span className="text-white font-weight-bold" style={{ letterSpacing: '1px', fontSize: '0.95rem' }}>
                            SWABHIMAN • BEING A NAVODIAN
                        </span>
                    </div>

                    {/* Right Actions */}
                    <div className="d-flex align-items-center gap-2">
                        {isAuth && authContext.item && authContext.item.smst_designation && (
                            <Badge bg="info" className="text-white px-2 py-1 d-none d-sm-inline-block" style={{ fontSize: '0.8rem' }}>
                                {authContext.item.smst_designation}
                            </Badge>
                        )}

                        {isAuth && (
                            <Link className="btn btn-outline-light btn-sm" to='/settings' title="Settings">
                                ⚙️ Settings
                            </Link>
                        )}

                        {isAuth ? (
                            <Link className="btn btn-danger btn-sm" to="/logout">
                                Sign Out
                            </Link>
                        ) : (
                            coreContext.pathName === '/login' || coreContext.pathName === '/' || coreContext.pathName === '/' + authContext.ownerId ? (
                                <Link className="btn btn-primary btn-sm" to="/add-user">
                                    Register Now
                                </Link>
                            ) : (
                                <Link className="btn btn-success btn-sm" to='/'>
                                    Sign In
                                </Link>
                            )
                        )}
                    </div>
                </div>
            </nav>

            {/* Banner Graphic */}
            <div className="text-center mb-3">
                <div className="d-inline-block shadow-sm rounded overflow-hidden border" style={{ maxWidth: '100%', maxHeight: '140px' }}>
                    <img
                        src={headerImage}
                        alt='Swabhiman Navodaya Banner'
                        className="img-fluid"
                        style={{ maxHeight: '140px', width: 'auto', objectFit: 'cover' }}
                    />
                </div>
            </div>
        </header>
    );
};

export default Menu;
